// extracted by mini-css-extract-plugin
module.exports = {"root":"NameEditor_root__2Bxrx","input":"NameEditor_input__1Sxne"};